import type { IView } from '@barba/core';
import { IdleQueue } from 'idlize/IdleQueue.mjs';
import pageAnimations from '../animations/pages/for-business/init-page-animations';
import pageHandlers from '../inits/pages/for-business/page-handlers';
import contactPopupModule from '@/inits/pages/index/contact-popup';
import reviewsSliderPopupsModule from '@/inits/components/common/reviews-slider-popups';

const beforeEnterQueue = new IdleQueue();

export default {
    namespace: 'for-business-page',

    beforeEnter({ next }) {
        beforeEnterQueue.pushTask(() => {
            pageAnimations.init();
            pageHandlers.init(next?.container);
            contactPopupModule.init();
            reviewsSliderPopupsModule.init();
        });
    },

    beforeLeave() {
        pageHandlers.destroy();
        contactPopupModule.destroy();
        reviewsSliderPopupsModule.destroy();
    },
} as IView;
